var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"value":_vm.paso,"type":"text","label":_vm.label,"hide-details":"","outlined":"","dense":"","disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/InputDownloadComponent.vue?vue&type=template&id=16572227
// module id = null
// module chunks = 